import { formatColumnValue } from 'helpers/formatters';
import { FormatOptions } from 'types';

export const moneyFormat = (amount: any) => {
  return formatColumnValue(FormatOptions.MONEY, amount);
};
